function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Grid } from '../Grid';
import { normalize } from '../interfaces/GridSortSettings';
import { ColumnResizer } from '../drag/ColumnResizer';
import { ColumnDraggable } from '../drag/ColumnDraggable';
import { GridHeaderCell } from './GridHeaderCell'; // import { GridColumnMenuProps } from '../interfaces/GridColumnMenuProps';

import { ColumnMenu } from '../columnMenu/ColumnMenu';
import { VueComponent, templateRendering } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
/**
 * @hidden
 */

var ariaSortMap = {
  'none': '',
  'asc': 'ascending',
  'desc': 'descending'
};
/**
 * @hidden
 */

var sortSeqMap = {
  true: {
    'asc': 'desc',
    'desc': '',
    '': 'asc'
  },
  false: {
    'asc': 'desc',
    'desc': 'asc',
    '': 'asc'
  }
};
/**
 * @hidden
 */

var HeaderRow =
/** @class */
function (_super) {
  __extends(HeaderRow, _super);

  function HeaderRow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._element = null;
    return _this;
  }

  Object.defineProperty(HeaderRow.prototype, "element", {
    get: function get() {
      return this._element;
    },
    enumerable: true,
    configurable: true
  });

  HeaderRow.prototype.created = function () {
    this.cellClick = this.cellClick.bind(this);
  };

  HeaderRow.prototype.pressHandler = function (event, element) {
    this.$emit('pressHandler', event, element);
  };

  HeaderRow.prototype.dragHandler = function (event, element) {
    this.$emit('dragHandler', event, element);
  };

  HeaderRow.prototype.releaseHandler = function (event) {
    this.$emit('releaseHandler', event);
  };

  HeaderRow.prototype.selectionChangeHandler = function (options) {
    this.$emit('selectionchange', options);
  };

  HeaderRow.prototype.cellClick = function (e, column) {
    e.preventDefault();

    if (!this.$listeners.sortChange) {
      return;
    }

    var _a = normalize(this.$props.sortable || false, column.sortable || false),
        allowUnsort = _a.allowUnsort,
        mode = _a.mode;

    var oldDescriptor = (this.$props.sort || []).filter(function (d) {
      return d.field === column.field;
    })[0];
    var dir = sortSeqMap[allowUnsort][oldDescriptor && oldDescriptor.dir || ''];
    var newDescriptor = mode === 'single' ? [] : (this.$props.sort || []).filter(function (d) {
      return d.field !== column.field;
    });

    if (dir !== '' && column.field) {
      newDescriptor.push({
        field: column.field,
        dir: dir
      });
    }

    this.sortChangeHandler(newDescriptor, {
      event: e,
      field: column.field
    });
  };

  HeaderRow.prototype.sortChangeHandler = function (newDescriptor, e) {
    this.$emit('sortChange', newDescriptor, e);
  };

  HeaderRow.prototype.filterChangeHandler = function (newDescriptor, e) {
    this.$emit('filterChange', newDescriptor, e);
  };

  HeaderRow.prototype.cellClass = function (field, headerClassName) {
    var customClass = headerClassName ? ' ' + headerClassName : '';

    if (this.$props.sort && this.$props.sort.filter(function (descriptor) {
      return descriptor.field === field;
    }).length > 0) {
      return 'k-header k-sorted' + customClass;
    }

    return 'k-header' + customClass;
  }; // @ts-ignore


  HeaderRow.prototype.render = function (h) {
    var _this = this;

    var cells = function cells(rowIndexes) {
      return rowIndexes.map(function (columnIndex, index) {
        var column = _this.$props.columns[columnIndex];
        var sortable = _this.$props.sortable && column.sortable;
        var sortIndex = _this.$props.sort ? _this.$props.sort.findIndex(function (s) {
          return s.field === column.field;
        }) : -1;
        var sortDir = sortIndex >= 0 ? _this.$props.sort[sortIndex].dir || 'none' : 'none';

        var sortIconRenderer = function sortIconRenderer(iconSortIndex) {
          if (!_this.$props.sort) {
            return null;
          }

          return iconSortIndex >= 0 && [h("span", {
            key: 1,
            "class": 'k-icon k-i-sort-' + _this.$props.sort[iconSortIndex].dir + '-sm'
          }), _this.$props.sort.length > 1 && h("span", {
            key: 2,
            "class": "k-sort-order"
          }, [iconSortIndex + 1])];
        };

        var sortIcon = sortIconRenderer(sortIndex);

        var className = (column.kFirst ? 'k-first ' : '') + _this.cellClass(column.field, column.headerClassName);

        var columnMenu = column.columnMenu || column.columnMenu === false ? column.columnMenu : _this.$props.columnMenu;
        var columnMenuRender = !columnMenu || typeof columnMenu === 'boolean' ? !!columnMenu : _this.getTemplate(columnMenu);
        var style = column.left !== undefined ? {
          position: 'sticky',
          left: column.left + 'px',
          right: column.right + 'px',
          zIndex: 1,
          background: '#f6f6f6',
          borderRightWidth: column.rightBorder ? '1px' : ''
        } : {};
        return h("th", {
          attrs: {
            "aria-sort": ariaSortMap[sortDir],
            colSpan: column.colSpan,
            rowSpan: column.rowSpan
          },
          key: index,
          "class": className,
          style: style
        }, [[column.children.length === 0 && columnMenu && h(ColumnMenu, {
          key: 0,
          attrs: {
            column: {
              field: column.field,
              filter: column.filter
            },
            sortable: sortable,
            sort: _this.$props.sort,
            filter: _this.$props.filter,
            filterable: _this.$props.filterable && column.filterable,
            render: columnMenuRender
          },
          on: {
            "sortchange": _this.sortChangeHandler,
            "filterchange": _this.filterChangeHandler
          }
        }), column.internalHeaderCell && h(column.internalHeaderCell, {
          key: 1,
          attrs: {
            field: column.field,
            sortable: sortable,
            selectionValue: column.headerSelectionValue,
            children: sortIconRenderer(sortIndex),
            title: column.title,
            render: (column.headerCell || _this.$props.cellRender) && _this.getTemplate(column.headerCell || _this.$props.cellRender)
          },
          on: {
            "click": function click(e) {
              return _this.cellClick(e, column);
            },
            "selectionchange": _this.selectionChangeHandler
          }
        }, [sortIcon]) || h(GridHeaderCell, {
          key: 1,
          attrs: {
            field: column.field,
            sortable: sortable,
            selectionValue: column.headerSelectionValue,
            title: column.title,
            render: (column.headerCell || _this.$props.cellRender) && _this.getTemplate(column.headerCell || _this.$props.cellRender)
          },
          on: {
            "click": function click(e) {
              return _this.cellClick(e, column);
            }
          }
        }, [sortIcon]), _this.$props.columnResize && _this.$props.columnResize.resizable && column.resizable && h(ColumnResizer, {
          key: 2,
          attrs: {
            resize: function resize(e, element, end) {
              return _this.$props.columnResize && _this.$props.columnResize.dragHandler(e, column, element, end);
            }
          }
        })]]);
      });
    };

    return h("thead", [this.$props.columnsMap.map(function (rowIndexes, i) {
      return (_this.$props.groupable || _this.$props.reorderable) && h(ColumnDraggable, {
        key: i,
        on: {
          "pressHandler": _this.pressHandler,
          "dragHandler": _this.dragHandler,
          "releaseHandler": _this.releaseHandler
        }
      }, [cells(rowIndexes)]) || h("tr", [cells(rowIndexes)]);
    }), this.$props.filterRow]);
  };

  HeaderRow.prototype.getTemplate = function (template) {
    return templateRendering.call(this.$props.grid, template, this.$props.grid.$listeners);
  };

  HeaderRow = __decorate([Component({
    props: {
      grid: Grid,
      cellRender: [String, Function, Object],
      groupable: [Boolean, Object],
      reorderable: Boolean,
      sortable: [Boolean, Object],
      sort: {
        type: Array
      },
      filter: Object,
      filterable: Boolean,
      filterChange: Function,
      filterRow: Object,
      columns: Array,
      columnsMap: Array,
      columnResize: Object,
      columnMenu: [Boolean, String, Function, Object]
    }
  })], HeaderRow);
  return HeaderRow;
}(VueComponent);

export { HeaderRow };